import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['container', 'content'];
  static classes = ['default', 'small', 'large']

  connect() {
    this.boundOpen = this.open.bind(this);
    this.boundClose = this.close.bind(this);
    this.boundPrepare = this.prepare.bind(this);

    document.addEventListener('modal:open', this.boundOpen);
    document.addEventListener('modal:close', this.boundClose);
    document.addEventListener('modal:prepare', this.boundPrepare);
  }

  disconnect() {
    document.removeEventListener('modal:open', this.boundOpen);
    document.removeEventListener('modal:close', this.boundClose);
    document.removeEventListener('modal:prepare', this.boundPrepare);
  }

  prepare() {
    const frame = document.querySelector("turbo-frame#active-modal-content");
    if (frame) frame.innerHTML = "";
  }

  async open(event) {
   const { src, size = "default" } = event.detail || {};

    const frame = document.querySelector("turbo-frame#active-modal-content");
    if (frame) {
      frame.innerHTML = ""; 
      if (src) {
        frame.setAttribute("src", src);
        // Wait for the content to load before displaying the modal
        await new Promise((resolve) => {
          const onLoad = () => {
            frame.removeEventListener("turbo:frame-load", onLoad);
            resolve();
          };
          frame.addEventListener("turbo:frame-load", onLoad);
        });
      }
    }

    this.containerTarget.classList.remove("hidden");
    this.contentTarget.classList.remove("modal-small", "modal-default", "modal-large");
    this.contentTarget.classList.add(`modal-${size}`);
  }

  close() {
    this.containerTarget.classList.add('hidden');
  }

  closeOnOutsideClick(event) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }
}